import { render } from "./EvaluationListView.vue?vue&type=template&id=fe523142"
import script from "./EvaluationListView.vue?vue&type=script&lang=js"
export * from "./EvaluationListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__